var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.358,
    height: 21.363,
    viewBox: "0 0 21.358 21.363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    "data-name": "Caminho 5",
    d: "M21.753,6.281a7.806,7.806,0,0,0-.5-2.592A5.472,5.472,0,0,0,18.13.563a7.826,7.826,0,0,0-2.591-.5C14.4.013,14.032,0,11.132,0s-3.263.013-4.4.063a7.808,7.808,0,0,0-2.591.5A5.212,5.212,0,0,0,2.243,1.795a5.26,5.26,0,0,0-1.231,1.89,7.827,7.827,0,0,0-.5,2.591C.461,7.42.449,7.783.449,10.683s.013,3.263.063,4.4a7.806,7.806,0,0,0,.5,2.592A5.471,5.471,0,0,0,4.134,20.8a7.827,7.827,0,0,0,2.592.5c1.139.05,1.5.063,4.4.063s3.263-.012,4.4-.063a7.8,7.8,0,0,0,2.591-.5,5.464,5.464,0,0,0,3.126-3.126,7.832,7.832,0,0,0,.5-2.592c.05-1.139.063-1.5.063-4.4s0-3.263-.054-4.4ZM19.829,15a5.855,5.855,0,0,1-.367,1.982,3.544,3.544,0,0,1-2.028,2.028,5.876,5.876,0,0,1-1.982.367c-1.127.05-1.465.063-4.315.063s-3.192-.012-4.315-.063a5.852,5.852,0,0,1-1.982-.367,3.287,3.287,0,0,1-1.227-.8,3.321,3.321,0,0,1-.8-1.227,5.877,5.877,0,0,1-.367-1.982c-.05-1.127-.063-1.465-.063-4.315S2.4,7.5,2.448,6.377a5.852,5.852,0,0,1,.367-1.982,3.247,3.247,0,0,1,.8-1.227,3.316,3.316,0,0,1,1.227-.8A5.88,5.88,0,0,1,6.825,2c1.127-.05,1.465-.063,4.315-.063s3.193.013,4.315.063a5.855,5.855,0,0,1,1.982.367,3.285,3.285,0,0,1,1.227.8,3.321,3.321,0,0,1,.8,1.227,5.879,5.879,0,0,1,.367,1.982c.05,1.127.063,1.465.063,4.315s-.013,3.184-.063,4.311Zm0,0",
    transform: "translate(-0.449 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6",
    "data-name": "Caminho 6",
    d: "M130.437,124.5a5.488,5.488,0,1,0,5.488,5.488A5.489,5.489,0,0,0,130.437,124.5Zm0,9.048a3.56,3.56,0,1,1,3.56-3.56A3.56,3.56,0,0,1,130.437,133.548Zm0,0",
    transform: "translate(-119.753 -119.304)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7",
    "data-name": "Caminho 7",
    d: "M365.012,89.883a1.281,1.281,0,1,1-1.281-1.281A1.281,1.281,0,0,1,365.012,89.883Zm0,0",
    transform: "translate(-347.343 -84.904)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.01b2ada96d3ce76b8671f17e63e70a78.svg";
export { ForwardRef as ReactComponent };